import MapWidget from "pages/Map/components/MapWidget";
import React from "react";
import "react-rangeslider/lib/index.css";
import "./index.scss";
import { Row, Col } from "reactstrap";
import Constant from "constants/index";
import PotentialZone from "pages/Map/components/PotentialZoneInformation";
import { MapData } from "pages/Map";
import Checkbox from "components/Checkbox";
import { AreaType } from "Models/map";
import Slider from "react-rangeslider";
import t from "utils/Lang";

type MenuInformationProps = {
  wardData: any;
  externalFoodAndBeverageCategories: MapData;
  externalFoodAndBeverageData: MapData;
  externalFoodAndBeverageDeliveryData: MapData;
  staticDemandData: MapData;
  externalRetailData: MapData;
  toggleZone: (enable: boolean) => void;
  enableZone: boolean;
  enablePopulate: boolean;
  togglePopulate: (enable: boolean) => void;
  enableArea: boolean;
  toggleArea: (enable: boolean) => void;
  enableRetailData: boolean;
  fetchRetailData: () => void;
  enableFoodAndBeverageData: boolean;
  fetchFoodAndBeverageData: () => void;
  enableFoodAndBeverageDeliveryData: boolean;
  fetchFoodAndBeverageDeliveryData: () => void;
  onChangeMapType: (id: string) => void;
  mapTypeId: string;
  selectedZone: any;
  toggleSitePlanningCommentUI: () => void;
  editPlanningPolygon: () => void;
  setCurrentMapDrawer: (drawer: any) => void;
  currentMapDrawer: any;
  enableStaticData: boolean;
  fetchStaticData: () => void;
  onSelectedAreaType: (id: AreaType) => void;
  areaType: AreaType;
  openPlanningZoneListing: () => void;
  embedMode?: boolean;
  isRadiusMode: boolean;
  setRadiusMode: (radius: boolean) => void;
  radiusVal: number;
  setRadiusVal: (val: number) => void;
  onRadiusCompleted: () => void;
  foodAndBeverageLoading: boolean;
  foodAndBeverageDeliveryLoading: boolean;
  staticLoading: boolean;
  retailLoading: boolean;
};

const MenuInformation = ({
  toggleZone,
  enableZone,
  enableArea,
  enablePopulate,
  toggleArea,
  togglePopulate,
  enableFoodAndBeverageData,
  enableFoodAndBeverageDeliveryData,
  enableRetailData,
  fetchFoodAndBeverageData,
  fetchFoodAndBeverageDeliveryData,
  fetchRetailData,
  mapTypeId,
  onChangeMapType,
  selectedZone,
  editPlanningPolygon,
  toggleSitePlanningCommentUI,
  currentMapDrawer,
  setCurrentMapDrawer,
  enableStaticData,
  fetchStaticData,
  externalFoodAndBeverageCategories,
  externalFoodAndBeverageData,
  externalFoodAndBeverageDeliveryData,
  externalRetailData,
  staticDemandData,
  wardData,
  onSelectedAreaType,
  areaType,
  openPlanningZoneListing,
  embedMode,
  isRadiusMode,
  setRadiusMode,
  radiusVal,
  setRadiusVal,
  onRadiusCompleted,
  foodAndBeverageLoading,
  foodAndBeverageDeliveryLoading,
  staticLoading,
  retailLoading,
}: MenuInformationProps) => {
  const summaryDataLayout: Array<any> = [
    {
      id: "widget-0-0",
      type: "single_toggle",
      action: (enable: boolean) =>
        setCurrentMapDrawer(enable ? Constant.MAP_DRAWING_TYPE[0] : null),
      defaultChecked: !!currentMapDrawer,
      title: t().map__draw_potential_area,
      // customBottomComponent: !!currentMapDrawer ? (
      //   <DrawerMenu
      //     currentMapDrawer={currentMapDrawer}
      //     setCurrentMapDrawer={setCurrentMapDrawer}
      //   />
      // ) : null,
    },
    {
      id: "widget-0",
      type: "single_toggle",
      action: toggleZone,
      defaultChecked: enableZone,
      title: t().map__show_potential_area,
      customBottomComponent: enableZone ? (
        <PotentialZone
          zone={selectedZone}
          editPlanningPolygon={editPlanningPolygon}
          toggleSitePlanningCommentUI={toggleSitePlanningCommentUI}
        />
      ) : null,
      buttonActions: [
        {
          label: t().map__planning_zone_list,
          action: openPlanningZoneListing,
        },
      ],
    },
    {
      id: "widget-0-1",
      type: "custom_body",
      title: t().map__type,
      customBody: (
        <Row>
          {Constant.mapTypes.map((type) => (
            <Col key={type.id} xs={6} sm={3} lg={2}>
              <img
                className={`site-planning__map-toolbar_map-type-item ${
                  type.id == mapTypeId ? "active" : ""
                }`}
                src={type.image}
                onClick={() => onChangeMapType(type.id)}
                alt={type.name}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      id: "widget-1",
      data: wardData?.wardDemographics?.totalPopulation || 0,
      type: "single_number",
      unit: t().map__people_unit,
      title: t().map__population,
      description: t().map__population_description,
      loading: wardData?.loading,
      toggleActions: [
        {
          label: t().map__show_area,
          defaultChecked: enableArea,
          action: toggleArea,
        },
        {
          label: t().map__show_density_population,
          defaultChecked: enablePopulate,
          action: togglePopulate,
        },
      ],
      customBottomComponent: (
        <div>
          <div className="custom-item">
            <Checkbox
              label={t().map__show_by_ward}
              onChange={() => {
                onSelectedAreaType("ward");
              }}
              type="radio"
              checked={areaType == "ward"}
            />
          </div>
          <div className="custom-item">
            <Checkbox
              label={t().map__show_by_district}
              onChange={() => {
                onSelectedAreaType("district");
              }}
              type="radio"
              checked={areaType == "district"}
            />
          </div>
          {/* <div className="custom-item">
            <Checkbox
              label="Hiển thị theo thành phố"
              onChange={() => {
                onSelectedAreaType("city");
              }}
              type="radio"
              checked={areaType == "city"}
            />
          </div> */}
        </div>
      ),
    },
    {
      id: "widget-2",
      data: wardData?.wardDemographics?.ageRangePopulation || [],
      type: "bar_chart",
      title: t().map__age,
      description: t().map__population_description,
      keyAttribute: "age_range",
      valueAttribute: "total_population",
      fromColor: [47, 124, 50],
      toColor: [217, 67, 20],
      loading: wardData?.loading,
    },
    {
      id: "widget-0-0-0",
      type: "single_toggle",
      action: (enable: boolean) => setRadiusMode(enable),
      defaultChecked: isRadiusMode,
      title: t().map__radius_mode,
      description: t().map__radius_description,
      customBottomComponent: isRadiusMode ? (
        <div style={{ padding: 5 }}>
          <Slider
            min={100}
            max={2000}
            step={100}
            value={radiusVal}
            orientation="horizontal"
            tooltip
            handleLabel={`${radiusVal / 1000}`}
            format={(val) => `${val / 1000}`}
            onChange={setRadiusVal}
            onChangeComplete={onRadiusCompleted}
          />
        </div>
      ) : null,
    },
    {
      id: "widget-4",
      data: externalFoodAndBeverageData?.data?.totalTransaction || 0,
      type: "single_number",
      unit: t().map__unit_deal,
      title: t().map__fb_demand,
      description: t().map__deal_from,
      loading: externalFoodAndBeverageData?.loading || foodAndBeverageLoading,
      buttonActions: [
        {
          label: t().map__show_on_map,
          defaultChecked: enableFoodAndBeverageData,
          action: fetchFoodAndBeverageData,
        },
      ],
    },
    {
      id: "widget-5",
      data: externalFoodAndBeverageCategories?.data || [],
      loading: externalFoodAndBeverageCategories?.loading,
      type: "bar_chart",
      title: t().map__fb_demand_type,
      description: t().map__deal_from,
      keyAttribute: "category",
      valueAttribute: "total_transaction",
      fromColor: [93, 53, 177],
      toColor: [124, 179, 67],
    },
    {
      id: "widget-6",
      data: externalFoodAndBeverageDeliveryData?.data?.totalTransaction || 0,
      loading:
        externalFoodAndBeverageDeliveryData?.loading ||
        foodAndBeverageDeliveryLoading,
      type: "single_number",
      unit: t().map__unit_deal,
      title: t().map__fb_demand_type_delivery,
      description: t().map__deal_from,
      buttonActions: [
        {
          label: t().map__show_on_map,
          defaultChecked: enableFoodAndBeverageDeliveryData,
          action: fetchFoodAndBeverageDeliveryData,
        },
      ],
    },
    {
      id: "widget-7",
      data: staticDemandData?.data?.totalTransaction || 0,
      loading: staticDemandData?.loading || staticLoading,
      type: "single_number",
      unit: t().map__unit_deal,
      title: t().map__ecommerce_demand,
      description: t().map__deal_from,
      buttonActions: [
        {
          label: t().map__show_on_map,
          defaultChecked: enableStaticData,
          action: fetchStaticData,
        },
      ],
    },
    {
      id: "widget-3",
      data: externalRetailData?.data || 0,
      type: "single_number",
      unit: t().map__unit_vnd,
      title: t().map__retail_demand,
      description: t().map__avg_revenue,
      loading: externalRetailData?.loading || retailLoading,
      buttonActions: [
        {
          label: t().map__show_on_map,
          defaultChecked: enableRetailData,
          action: fetchRetailData,
        },
      ],
    },
  ];
  const renderWidget = (layoutItem: any) => (
    <MapWidget key={layoutItem.id} layoutItem={layoutItem} />
  );
  return <div>{summaryDataLayout.map(renderWidget)}</div>;
};

export default MenuInformation;
